<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('inprogress_jobs')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getListAction" />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../core/helpers/app/AppFunction";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      selectedUrl: "",
      search: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.INPROGRESS_JOBS,
        tableShadow: false,
        showHeader: true,
        columns: [
          // {
          //   title: this.$t("company"),
          //   type: "media-object",
          //   key: "media-object",
          //   mediaTitleKey: "title",
          //   mediaSubtitleKey: "location",
          //   default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
          //   modifier: (value, row) => {
          //     return value; // imag url
          //   },
          //   isVisible: true,
          // },
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          // {
          //   title: this.$t("company"),
          //   type: "custom-html",
          //   key: "accepted_bids",
          //   modifier: (value) => {
          //     return `<span>${this.$t(value[0].company_name)}</span>`;
          //   },
          // },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("end_date"),
            type: "custom-html",
            key: "end_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("job_type"),
            type: "custom-html",
            key: "job_type",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "warning";

              if (value === "active") ClassName = `success`;
              else if (value === "inactive") ClassName = `danger`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          // {
          //     title: this.$t('phone'),
          //     type: 'text',
          //     key: 'phone',
          // },
          // {
          //     title: this.$t('gender'),
          //     type: 'custom-html',
          //     key: 'gender',
          //     modifier: (value) => {
          //         return `<span>${this.$t(value)}</span>`
          //     }
          // },
        ],
        actions: [
          {
            title: this.$t("job_management"),
            icon: "clipboard",
            type: "none",
          },
        ],
        filters: [
          //   {
          //     title: this.$t("date"),
          //     type: "range-picker",
          //     key: "date",
          //     option: ["today", "thisMonth", "last7Days", "nextYear"],
          //   },
          {
            title: this.$t("is_private"),
            type: "checkbox",
            key: "is_private",
            option: [
              { id: "0", value: "Public" },
              { id: "1", value: "Private" },
            ],
          },
          {
            title: this.$t("location"),
            type: "drop-down-filter",
            key: "search select",
            option: [
              { id: "0", value: "UK" },
              { id: "1", value: "USA" },
            ],
          },
          {
            title: this.$t("region"),
            type: "drop-down-filter",
            key: "search select",
            option: [
              { id: "0", value: "Public" },
              { id: "1", value: "Private" },
            ],
          },
          {
            title: this.$t("threshold"),
            type: "drop-down-filter",
            key: "search select",
            option: [
              { id: "0", value: "Threshold 1" },
              { id: "1", value: "Threshold 1" },
            ],
          },
          //   {
          //     title: this.$t("status"),
          //     type: "checkbox",
          //     key: "status",
          //     option: [
          //       { id: "completed", value: "Completed" },
          //       { id: "incomplete", value: "Incomplete" },
          //       // {id: 'invited', value: 'Invited'},
          //     ],
          //   },
          {
            title: this.$t("search_and_select_category"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },

  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("job_management")) {
        window.location = "management/" + rowData.id;
      }
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
  },
};
</script>
